// The devops report a `pr` run delivers BESIDE its pull request (owner 2026-11-03, "give
// POWER": the fix is a devops run's default deliverable, and its findings must not die with
// the checkout just because the run shipped code).
//
// WHY A STATUS EVENT AND NOT THE `report` KIND. `ReportPayloadSchema.outcome_kind` is
// `report | ops_action`, and every reader of that kind treats it as "this run delivered a
// report INSTEAD of a change": the event sink corrects `tasks.outcome_kind` off it
// (`applyReportOutcome`), the narration renders it as "a report, not a change", and the
// ask-close loop files it as the issue's diagnosis. A `pr` run's report is none of those,
// so it rides its own name and no existing reader changes meaning.
//
// THREE PARTIES, which is why it lives here: the box writes it (`apps/runner` devops lane),
// the db names it a deliverable (`DELIVERABLE_STATUS_EVENTS`), and `task result`
// (`@developerz/mcp`) folds it into the run's `report`.

import { z } from 'zod';

/** The status event a devops `pr` run's findings ride. */
export const DEVOPS_REPORT_EVENT = 'devops_report';

/** Same ceiling as `ReportPayloadSchema.markdown`, so one body fits either carrier. */
export const DEVOPS_REPORT_MARKDOWN_MAX = 100_000;

/**
 * Where the findings came from: the lane's probe survey (`probe_survey`), or no survey ran on
 * this run (`no_survey` — no probe model on the box, `DZ_DEVOPS_MAX_PROBES=0`, or it threw;
 * the body says which it can).
 */
export const DevopsReportSourceSchema = z.enum(['probe_survey', 'no_survey']);
export type DevopsReportSource = z.infer<typeof DevopsReportSourceSchema>;

export const DevopsReportPayloadSchema = z.object({
  markdown: z.string().max(DEVOPS_REPORT_MARKDOWN_MAX),
  source: DevopsReportSourceSchema,
  /** Raw tasks this run filed (`raw_task_filed`), the count the summary carries. */
  raw_tasks_filed: z.number().int().nonnegative(),
  /** Whether this run declared an access blocker (`devops_blocked`). */
  blocked: z.boolean(),
});
export type DevopsReportPayload = z.infer<typeof DevopsReportPayloadSchema>;
